import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MyNoticeIcon } from './img/notice.svg'

type NoticeIconProps = IconWrapperProps

export const NoticeIcon: FC<NoticeIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyNoticeIcon />
    </IconWrapper>
  )
}
